import logo from './logo.svg';
import './App.css';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import React, { useState } from 'react';
import HeaderNew from './components/HeaderNew'
import NavBarNew from './components/NavBarNew'
import OverlayNew from './components/OverlayNew'



function App() {
const [pageKey, setPageKey] = useState(0);
const [section, setSection] = useState("Home");
const handleSelect = (section) => {
  setSection(section);

  if (section === "Home") {
    setPageKey(prev => prev + 1); // 👈 fuerza reset
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
  return (

   <div >
        <NavBarNew onSelect={handleSelect} />

        <HeaderNew key={pageKey} section={section} />
        <div className="copyright py-4 text-center text-white">
        <div className="container"><div className= "font-face-CabinSketch "><small> &copy; Cecilia García 2026</small></div></div>
    </div>



    
    </div>
 



 


  );
}
window.addEventListener('DOMContentLoaded', event => {

    // Navbar shrink function
    var navbarShrink = function () {
        const navbarCollapsible = document.body.querySelector('#mainNav');
        if (!navbarCollapsible) {
            return;
        }
        if (window.scrollY === 0) {
            navbarCollapsible.classList.remove('navbar-shrink')
        } else {
            navbarCollapsible.classList.add('navbar-shrink')
        }
  
    };
  
    // Shrink the navbar 
    navbarShrink();
  
    // Shrink the navbar when page is scrolled
    document.addEventListener('scroll', navbarShrink);
  
   
  
    // Collapse responsive navbar when toggler is visible
    const navbarToggler = document.body.querySelector('.navbar-toggler');
    const responsiveNavItems = [].slice.call(
        document.querySelectorAll('#navbarResponsive .nav-link')
    );
    responsiveNavItems.map(function (responsiveNavItem) {
        responsiveNavItem.addEventListener('click', () => {
            if (window.getComputedStyle(navbarToggler).display !== 'none') {
                navbarToggler.click();
            }
        });
    });
  
  });
export default App;
